module.exports = __webpack_public_path__ + "static/media/i5.1415dd9a.png";